import { render, staticRenderFns } from "./LoanModal.vue?vue&type=template&id=16c2e096"
import script from "./LoanModal.vue?vue&type=script&lang=js"
export * from "./LoanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports